import { render, staticRenderFns } from "./CMCourseCountsCurss.vue?vue&type=template&id=00bd3c6a&scoped=true&lang=pug&"
import script from "./CMCourseCountsCurss.vue?vue&type=script&lang=js&"
export * from "./CMCourseCountsCurss.vue?vue&type=script&lang=js&"
import style0 from "./CMCourseCountsCurss.vue?vue&type=style&index=0&id=00bd3c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd3c6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
